export { default as Img200 } from './processed/200/Mary-Queen-of-Scots.jpg';
export { default as Img400 } from './processed/400/Mary-Queen-of-Scots.jpg';
export { default as Imgthumb } from './processed/thumb/Mary-Queen-of-Scots.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Mary-Queen-of-Scots.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Mary-Queen-of-Scots.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      160,
      92,
      51
    ],
    "_population": 151,
    "_hsl": [
      0.06269113149847094,
      0.5165876777251185,
      0.4137254901960784
    ]
  },
  "LightVibrant": {
    "_rgb": [
      251,
      217,
      195
    ],
    "_population": 329,
    "_hsl": [
      0.0654761904761905,
      0.875,
      0.8745098039215686
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      111,
      62,
      39
    ],
    "_population": 2404,
    "_hsl": [
      0.053240740740740734,
      0.48,
      0.29411764705882354
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      111,
      93
    ],
    "_population": 231,
    "_hsl": [
      0.04687500000000001,
      0.25600000000000006,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      161,
      139,
      125
    ],
    "_population": 234,
    "_hsl": [
      0.06481481481481478,
      0.16071428571428573,
      0.5607843137254902
    ]
  },
  "DarkMuted": {
    "_rgb": [
      33,
      45,
      62
    ],
    "_population": 2322,
    "_hsl": [
      0.5977011494252874,
      0.3052631578947368,
      0.18627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Mary-Queen-of-Scots.js